module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activity_container"
  }, [_c('div', {
    staticClass: "hd activity-background-color"
  }, [_c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("援鄂医生认证")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasLogin),
      expression: "hasLogin"
    }],
    staticClass: "box"
  }, [_c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "progress-background"
  }, [_c('div', {
    staticClass: "progress-ball",
    staticStyle: {
      "left": "0"
    }
  }), _vm._v(" "), (_vm.stage !== 1) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "0"
    }
  }, [_c('div', {
    staticClass: "progress-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-ball",
    staticStyle: {
      "left": "23.5vw"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.stage === 3 || _vm.stage === 4) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "25vw"
    }
  }, [_c('div', {
    staticClass: "progress-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-ball",
    staticStyle: {
      "left": "23.5vw"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.stage === 4) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "50vw"
    }
  }, [_c('div', {
    staticClass: "progress-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-ball",
    staticStyle: {
      "left": "23.5vw"
    }
  })]) : _vm._e()]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.stage === 1) ? _c('div', {
    staticClass: "personal-detail"
  }, [(_vm.hasLogin) ? _c('div', {
    staticClass: "main-upload-container",
    staticStyle: {
      "height": "156px",
      "align-items": "flex-start"
    }
  }, [_c('div', {
    staticClass: "activity-cell"
  }, [_c('div', {
    staticClass: "cell-outer"
  }, [_c('span', {
    staticClass: "attr-key"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('span', {
    staticClass: "attr-value"
  }, [_vm._v(_vm._s(_vm.customerName))])])]), _vm._v(" "), _c('div', {
    staticClass: "activity-cell"
  }, [_c('div', {
    staticClass: "cell-outer"
  }, [_c('span', {
    staticClass: "attr-key"
  }, [_vm._v("手机")]), _vm._v(" "), _c('span', {
    staticClass: "attr-value"
  }, [_vm._v(_vm._s(_vm.mobile))])])]), _vm._v(" "), _c('div', {
    staticClass: "activity-cell"
  }, [_c('div', {
    staticClass: "cell-outer"
  }, [_c('span', {
    staticClass: "attr-key"
  }, [_vm._v("单位")]), _vm._v(" "), _c('span', {
    staticClass: "attr-value"
  }, [_vm._v(_vm._s(_vm.enterpriseName))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('div', {
    staticClass: "button-wrap activity-background-color",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        return _vm.goToNextStep()
      }
    }
  }, [_c('span', {
    staticClass: "button-name"
  }, [_vm._v("下一步")])])])]) : _vm._e(), _vm._v(" "), (_vm.stage === 2) ? _c('div', {
    staticClass: "upload-identification"
  }, [_c('div', {
    staticClass: "main-upload-container",
    style: ('height: 206px;background-image:url(' + _vm.url + ');background-repeat:no-repeat;background-size:100% 100%;')
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_c('iframe', {
    staticClass: "identity-icon",
    style: (_vm.ifShowIcon),
    attrs: {
      "src": "/static/img/identification.svg"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "width": ".5px",
      "opacity": "0"
    },
    attrs: {
      "type": "file",
      "id": "imgFile"
    },
    on: {
      "change": function($event) {
        return _vm.changeImagePositive($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "add-icon",
    attrs: {
      "for": "imgFile"
    }
  })]), _vm._v(" "), (!_vm.url) ? _c('span', {
    staticClass: "upload-identification-instruction"
  }, [_vm._v("请上传您的工作证/学生证/身份证")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "remind-info"
  }, [_vm._v("注：由于微信浏览器的限制，部分机型可能出现无法上传照片的情况，请尝试点击右上角按钮，在其他浏览器中打开完成认证（需要重新登录）")]), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('div', {
    staticClass: "button-up",
    staticStyle: {
      "width": "45%"
    },
    on: {
      "click": function($event) {
        return _vm.goToLastStep()
      }
    }
  }, [_c('span', {
    staticClass: "button-name"
  }, [_vm._v("返回上一步")])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrap activity-background-color",
    staticStyle: {
      "width": "45%"
    },
    on: {
      "click": function($event) {
        return _vm.goToNextStep()
      }
    }
  }, [_c('span', {
    staticClass: "button-name"
  }, [_vm._v("下一步")])])])]) : _vm._e(), _vm._v(" "), (_vm.stage === 3 && _vm.showSearchContact === false) ? _c('div', {
    staticClass: "choose-discount-owner"
  }, [_c('div', {
    staticClass: "choose-owner",
    on: {
      "click": function($event) {
        return _vm.uploadIdentification(_vm.customerName, _vm.mobile)
      }
    }
  }, [_c('span', {
    staticClass: "discount-for"
  }, [_vm._v("折扣券自用")]), _vm._v(" "), _c('svg', {
    staticClass: "choose-icon",
    attrs: {
      "t": "1583809028111",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "1461",
      "width": "200",
      "height": "200"
    }
  }, [_c('path', {
    attrs: {
      "data-v-c24bfab2": "",
      "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
      "fill": "#929292",
      "p-id": "1462"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "choose-owner",
    on: {
      "click": function($event) {
        return _vm.toggleShowSearchContact()
      }
    }
  }, [_c('span', {
    staticClass: "discount-for",
    staticStyle: {
      "color": "#ff9400"
    }
  }, [_vm._v("折扣券转赠")]), _vm._v(" "), _c('svg', {
    staticClass: "choose-icon",
    attrs: {
      "t": "1583809028111",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "1461",
      "width": "200",
      "height": "200"
    }
  }, [_c('path', {
    attrs: {
      "data-v-c24bfab2": "",
      "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
      "fill": "#929292",
      "p-id": "1462"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('div', {
    staticClass: "button-wrap activity-background-color",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        return _vm.goToLastStep()
      }
    }
  }, [_c('span', {
    staticClass: "button-name"
  }, [_vm._v("返回上一步")])])])]) : _vm._e(), _vm._v(" "), (_vm.stage === 4) ? _c('div', {
    staticClass: "finish-process"
  }, [_c('span', {
    staticClass: "first-line"
  }, [_vm._v("您已经成功完成认证")]), _vm._v(" "), _c('span', {
    staticClass: "second-line"
  }, [_vm._v("奖励将在3-5个工作日内发送完毕")]), _vm._v(" "), _c('div', {
    staticClass: "button-wrap activity-background-color",
    staticStyle: {
      "width": "87%",
      "margin-top": "6.93vw"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('span', {
    staticClass: "button-name"
  }, [_vm._v("返回主页")])])]) : _vm._e(), _vm._v(" "), (_vm.stage === 3 && _vm.showSearchContact) ? _c('search-contact', {
    on: {
      "finish": _vm.uploadIdentification,
      "toggleShow": function($event) {
        return _vm.toggleShowSearchContact()
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-stage"
  }, [_c('span', {
    staticClass: "progress-text"
  }, [_vm._v("信息确认")]), _vm._v(" "), _c('span', {
    staticClass: "progress-text"
  }, [_vm._v("上传工牌")]), _vm._v(" "), _c('span', {
    staticClass: "progress-text"
  }, [_vm._v("自用或转赠")]), _vm._v(" "), _c('span', {
    staticClass: "progress-text"
  }, [_vm._v("完成认证")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a8c0d09","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Activities/ActivityDoctor.vue
// module id = 1556
// module chunks = 8